export const UIConfig = {
    icons: {
        back: { key: 'back', path: 'assets/icons/back.svg' },
        left: { key: 'left', path: 'assets/icons/left.svg' },
        right: { key: 'right', path: 'assets/icons/right.svg' },
        rotate: { key: 'rotate', path: 'assets/icons/rotate.svg' },
        drop: { key: 'drop', path: 'assets/icons/drop.svg' },
        volume: { key: 'volume', path: 'assets/icons/volume.svg' },
        down: { key: 'down', path: 'assets/icons/down.svg' },
        close: { key: 'close', path: 'assets/icons/close.svg' },
        home: { key: 'home', path: 'assets/icons/home.svg' },
        setting: { key: 'setting', path: 'assets/icons/setting.svg' },
        refresh: { key: 'refresh', path: 'assets/icons/refresh.svg' },
        search: { key:'search', path: 'assets/icons/search.svg' },
    }
};